const MODULE_NAME = 'BROWSERS';
const BROWSERS_FETCH_STARTED = MODULE_NAME + 'FETCH_STARTED';
const BROWSERS_FETCH_COMPLETED = MODULE_NAME + 'FETCH_COMPLETED';
const BROWSERS_DELETE_STARTED = MODULE_NAME + 'DELETE_STARTED';
const BROWSERS_DELETE_COMPLETED = MODULE_NAME + 'DELETE_COMPLETED';

export {
  BROWSERS_FETCH_COMPLETED, BROWSERS_FETCH_STARTED, BROWSERS_DELETE_STARTED, BROWSERS_DELETE_COMPLETED
};
